export default "__VITE_ASSET__f0c0a2ab__"